import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { useStyles } from "./utils/cutoffDate-styles";
import clsx from "clsx";
export const DateTimeDisplay = ({ value, type, isDanger, showColon, align }) => {
    const classes = useStyles();
    return (_jsxs(_Fragment, { children: [_jsxs(Box, Object.assign({ className: `${clsx(classes.countdown, {
                    [classes.alignColLeft]: align === "left",
                    [classes.alignColCenter]: align === "center",
                    [classes.alignColRight]: align === "right",
                })} ${isDanger ? classes.countdownDanger : ''}` }, { children: [value, _jsx(Box, Object.assign({ className: classes.timeDenomination }, { children: type }))] })), showColon && ':'] }));
};
